import React, { FC } from 'react'
import styled from '@emotion/styled'

import { useAuth } from 'core/auth'
import { WalletEnum } from 'shared/config'
import { useLoginModal, useMemoizedFn } from 'shared/hooks'

import { Image, Modal } from 'antd'

import imageMetaMask from 'assets/metamask.png'
import imagePhantom from 'assets/phantom.png'

export const LoginModal: FC = () => {
    const {
        visible,
        methods: { hide }
    } = useLoginModal()

    const {
        hasEthereum,
        hasSolana,
        methods: { connect }
    } = useAuth()

    const handleConnectMetaMask = useMemoizedFn(() => {
        if (hasEthereum) {
            connect(WalletEnum.METAMASK)
            return
        }
        window.open('https://metamask.io/')
    })

    const handleConnectPhantom = useMemoizedFn(() => {
        if (hasSolana) {
            connect(WalletEnum.PHANTOM)
            return
        }
        window.open('https://phantom.app/')
    })

    return (
        <Modal centered visible={visible} footer={null} width={452} onCancel={hide}>
            <Title>Connect Your Wallet</Title>
            <Desc>Connect with one of our available wallet providers</Desc>
            <WalletWrapper onClick={handleConnectMetaMask}>
                <Name>{hasEthereum ? 'MetaMask' : 'Install MetaMask'}</Name>
                <Image src={imageMetaMask} width={44} preview={false} />
            </WalletWrapper>
            <WalletWrapper onClick={handleConnectPhantom}>
                <Name>{hasSolana ? 'Phantom' : 'Install Phantom'}</Name>
                <Image src={imagePhantom} width={44} preview={false} />
            </WalletWrapper>
        </Modal>
    )
}

const Name = styled.div`
    font-family: OpenSans-SemiBold;
    font-size: 18px;
    font-weight: bold;
`

const WalletWrapper = styled.div`
    margin: 20px 30px;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    border: 1px solid rgba(196, 196, 211, 1);
    border-radius: 12px;
    cursor: pointer;

    :hover {
        border: 1px solid rgba(0, 0, 0, 1);
    }
`

const Desc = styled.div`
    text-align: center;
    margin: 16px 0;
    font-family: Roboto-Medium;
    font-size: 14px;
    color: #787878;
`

const Title = styled.div`
    text-align: center;
    margin-top: 24px;
    font-family: OpenSans-Bold;
    font-size: 24px;
    color: #000;
    line-height: 35px;
    font-weight: bold;
`
